import * as React from "react";
import { IconProps } from "../types";

// phone-outline's handset, turned face-down and scaled to fit the 18px box.
const PhoneHangUpOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          transform="translate(9 9.75) rotate(135) scale(0.78) translate(-9.5 -9)"
          d="M11.847 10.646L10.706 12.072C8.939 11.033 7.466 9.56101 6.428 7.79401L7.854 6.65301C8.198 6.37801 8.313 5.90501 8.134 5.50301L6.834 2.57601C6.641 2.14201 6.163 1.91201 5.704 2.03101L3.229 2.67301C2.751 2.79801 2.442 3.26101 2.51 3.75001C3.402 10.104 8.396 15.098 14.751 15.991C15.24 16.058 15.703 15.749 15.827 15.272L16.469 12.797C16.588 12.338 16.358 11.861 15.925 11.668L12.998 10.368C12.596 10.189 12.124 10.304 11.848 10.647L11.847 10.646Z"
          stroke={color}
          strokeWidth="1.92"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

export default PhoneHangUpOutlineIcon;
